import Swal from "sweetalert2";
import { updateInfo, deleteInfo } from "../info";
import { SettingContainer } from "./SettingContainer";
import { SettingTitle } from "./SettingTitle";
import { SettingText } from "./SettingText";
import { Button } from "./Button";

const title = {
  OFFICIAL: "공식",
  EXTERNAL: "외부"
};

export function AnimeLinkSettings(props) {
  function onEditClick(e, type, id) {
    const link = props.anime.links[type.toLowerCase()].find(link => link.id === id);

    Swal.fire({
      title: title[type] + " 링크 수정",
      html: [
        `<input id="swal2-text" class="swal2-input" value=${JSON.stringify(link.text)}>`,
        `<input id="swal2-url" class="swal2-input" value=${JSON.stringify(link.url)}>`
      ].join(""),
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "저장",
      denyButtonText: "삭제",
      cancelButtonText: "취소",
      icon: "info",
      preConfirm: () => new Promise((resolve) => resolve({
        text: document.getElementById("swal2-text").value,
        url: document.getElementById("swal2-url").value
      })),
      preDeny: () => new Promise((resolve) => {
        Swal.fire({
          title: title[type] + " 링크 삭제",
          text: `정말로 ${link.text} 링크를 삭제하시겠습니까?`,
          showConfirmButton: false,
          showDenyButton: true,
          showCancelButton: true,
          denyButtonText: "삭제",
          cancelButtonText: "취소",
          icon: "question",
        })
          .then(result => resolve(result.isDenied))
      })
    }).then(result => {
      if (result.isConfirmed) {
        updateInfo(`/anime/${props.anime.id}/links/${type.toLowerCase()}/${id}`, result.value, title[type] + " 링크", props.onSave);
      } else if (result.isDenied) {
        deleteInfo(`/anime/${props.anime.id}/links/${type.toLowerCase()}/${id}`, title[type] + " 링크", props.onSave);
      }
    });
  }

  function onCreateClick(e, type) {
    Swal.fire({
      title: title[type] + " 링크 추가",
      html: [
        "<input id='swal2-text' class='swal2-input' placeholder='YouTube'>",
        "<input id='swal2-url' class='swal2-input' placeholder='https://youtube.com/'>"
      ].join(""),
      showCancelButton: true,
      confirmButtonText: "추가",
      cancelButtonText: "취소",
      icon: "info",
      preConfirm: () => new Promise((resolve) => resolve({
        text: document.getElementById("swal2-text").value,
        url: document.getElementById("swal2-url").value
      }))
    }).then(result => {
      if (result.isConfirmed) {
        updateInfo(`/anime/${props.anime.id}/links/${type.toLowerCase()}`, result.value, title[type] + " 링크", props.onSave, "POST");
      }
    });
  }

  return (<>
    <SettingTitle text="링크"/>

    <SettingContainer>
      <SettingText text="공식"/>
      {
        props.anime.links.official.map((link, i) => (
          <Button key={ i } text={ link.text } description={ link.url } onClick={ (e) => onEditClick(e, "OFFICIAL", link.id) }/>
        ))
      }
      <Button text="추가하기" onClick={ (e) => onCreateClick(e, "OFFICIAL") }/>
    </SettingContainer>

    <SettingContainer>
      <SettingText text="외부"/>
      {
        props.anime.links.external.map((link, i) => (
          <Button key={ i } text={ link.text } description={ link.url } onClick={ (e) => onEditClick(e, "EXTERNAL", link.id) }/>
        ))
      }
      <Button text="추가하기" onClick={ (e) => onCreateClick(e, "EXTERNAL") }/>
    </SettingContainer>
  </>);
}
